import { LevelDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class LevelResponseModel extends GlobalResponseObject {
    data?: LevelDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /LevelDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: LevelDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 